import { render, staticRenderFns } from "./AllCandidatesHeader.vue?vue&type=template&id=3a8075e3&scoped=true"
import script from "./AllCandidatesHeader.vue?vue&type=script&lang=ts"
export * from "./AllCandidatesHeader.vue?vue&type=script&lang=ts"
import style0 from "./AllCandidatesHeader.vue?vue&type=style&index=0&id=3a8075e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8075e3",
  null
  
)

export default component.exports